import { useEffect } from 'react'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

import { usePostHog } from '@posthog/react'

export const CookieConsentManager = () => {
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) {
      return
    }

    const syncFromCookie = () => {
      const storedConsent = CookieConsent.getCookie()
      if (!storedConsent) {
        return
      }

      if (storedConsent.categories?.includes('analytics')) {
        posthog.opt_in_capturing()
        posthog.capture('$pageview')
      } else {
        posthog.opt_out_capturing()
      }
    }

    void CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: 'box inline',
          position: 'bottom right',
        },
        preferencesModal: {
          layout: 'box',
          position: 'right',
          equalWeightButtons: true,
          flipButtons: false,
        },
      },
      categories: {
        necessary: {
          readOnly: true,
        },
        analytics: {},
      },
      language: {
        default: 'en',
        translations: {
          en: {
            consentModal: {
              title: 'We use cookies! 🍪',
              description:
                'We use cookies to enhance your browsing experience and analyze our traffic. By clicking “Accept all”, you consent to our use of cookies.',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              showPreferencesBtn: 'Manage preferences',
            },
            preferencesModal: {
              title: 'Cookie preferences',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              savePreferencesBtn: 'Save preferences',
              closeIconLabel: 'Close',
              sections: [
                {
                  title: 'Cookie usage',
                  description:
                    'We use cookies to ensure the basic functionalities of the website and to enhance your online experience.',
                },
                {
                  title: 'Strictly necessary cookies <span class="pm__badge">Always enabled</span>',
                  description: 'These cookies are essential for the proper functioning of the website.',
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Analytics cookies',
                  description:
                    'These cookies help us understand how visitors interact with our website by collecting anonymous information.',
                  linkedCategory: 'analytics',
                },
              ],
            },
          },
        },
      },
      onConsent: ({ cookie }) => {
        if (cookie.categories.includes('analytics')) {
          posthog.opt_in_capturing()
          posthog.capture('$pageview')
        }
      },
      onChange: ({ cookie, changedCategories }) => {
        if (changedCategories.includes('analytics')) {
          if (cookie.categories.includes('analytics')) {
            posthog.opt_in_capturing()
            posthog.capture('$pageview')
          } else {
            posthog.opt_out_capturing()
          }
        }
      },
    })
      .then(syncFromCookie)
      .catch((error) => {
        console.error('CookieConsent initialization failed', error)
      })

    syncFromCookie()
  }, [posthog])

  return null
}

